import styled from 'styled-components';

export const LoginModalDialog = styled.dialog`
  z-index: 10000004;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  padding: 0;
  width: 316px;
`;

export const LoginModalBackdrop = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 100000;
`;
